export function validateWorkerPlanChange(currentSubscription, selectedPlan, noOfWorkers, workerCount, enqueueSnackbar, setLoading) {
  if (currentSubscription?.id < parseInt(selectedPlan)) {
    if (noOfWorkers === workerCount) {
      enqueueSnackbar(
        'You already have this many workers assigned. Please select a higher limit.',
        { variant: 'warning' }
      );
      setLoading(false);
      return false;
    }
  }

  if (currentSubscription?.id > parseInt(selectedPlan)) {
    if (noOfWorkers < workerCount) {
      enqueueSnackbar(
        `Cannot downgrade to a plan with only ${noOfWorkers} workers. You already have ${workerCount} active workers.`,
        { variant: 'warning' }
      );
      setLoading(false);
      return false;
    }
  }

  return true;
} 